<template>
    <div class="signSuc">
        <div class="box">
            <fillBgBox :bgImg="bg">
                <div class="content">
                    <img src="@/assets/img/sign/Ok.svg" alt="">
                    <h3>{{langPage['v4-signpage']['TXT_mercipourvotre']}}</h3>
                    <div class="tip" v-html="langPage['v4-signsuc']['TAREA_nousreviendronstresprochainement']"></div>
                    <router-link to="/" class="blackBtn">{{ langPage['v4-signsuc']['TXT_retouralaccueil'] }}</router-link>
                </div>
            </fillBgBox>
        </div>
    </div>
</template>

<script>
    import fillBgBox from "../../components/fillBgBox";
    import {mapState} from "vuex";
    export default {
        name: "choose",
        components: {fillBgBox},
        methods: {},
      computed: {
        ...mapState({
          acheteurId: state => state.acheteurId
        }),
        langPage() {
          return this.$store.state['langPage']
        }
      },
        data() {
            return {
                bg:require('../../assets/img/sign/signsucBg.svg')
            }
        }
    }
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Sign/SignSuc.less">
</style>
